import { SuccessApiResponse } from '../types'
import oldApiResponse from './old-api-response.adapter'
import newApiResponse from './new-api-response.adapter'

export default async function strategy<T>({
  response,
  json,
}: {
  response: Response
  json: any
}): Promise<SuccessApiResponse<T> | null> {
  const status = json?.status
  const notice = json?.notice
  const message = json?.message || notice
  const oldApiAdapter = await oldApiResponse<T>({ response, json })
  const newApiAdapter = await newApiResponse<T>({ response, json })
  if (!!oldApiAdapter?.ok) return oldApiAdapter
  if (!!newApiAdapter?.ok) return newApiAdapter
  if (!!status || status === 0) throw new Error(message)
  return null
}
